import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AUTH_PATH } from '../shared/constants';
import { AuthComponent } from './auth.component';

const routes: Routes = [
  {
    path: AUTH_PATH,
    component: AuthComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
